import styled from "@emotion/styled";
import type { CSSObject, Theme } from "@emotion/react";
import { Skeleton } from "@mui/material";

export const Content = styled.section(({ theme }) => ({
	backgroundColor: theme.project.colors.backgroundColors.main,
	border: `1px solid ${theme.palette.divider}`,
	margin: "12px 16px 24px",
	minHeight: 430,
	padding: "16px 24px 32px",

	[theme.breakpoints.down("sm")]: {
		margin: 16,
		padding: "16px 12px 24px"
	}
}));

export const Prompt = styled.h2(({ theme }) => ({
	...theme.project.typography.body.body1,
	color: theme.project.colors.fontColors.main,
	fontSize: 24,
	fontWeight: 400,
	lineHeight: "133%",
	margin: 0
}));

export const StandardOptions = styled.div(({ theme }) => ({
	display: "grid",
	gap: 32,
	gridTemplateColumns: "repeat(4, 250px)",
	justifyContent: "center",
	marginTop: 32,

	[theme.breakpoints.down("md")]: {
		gridTemplateColumns: "repeat(2, 250px)"
	},

	[theme.breakpoints.down("sm")]: {
		gridTemplateColumns: "250px"
	}
}));

export const ConditionalOptions = styled.div(({ theme }) => ({
	display: "flex",
	flexWrap: "wrap",
	gap: 32,
	justifyContent: "center",
	marginTop: 32,

	[theme.breakpoints.down("sm")]: {
		flexDirection: "column",
		alignItems: "center"
	}
}));

const optionStyles = (theme: Theme): CSSObject => ({
	alignItems: "center",
	backgroundColor: theme.project.colors.backgroundColors.main,
	border: `1px solid ${theme.palette.divider}`,
	borderRadius: "50%",
	boxShadow: "0 3px 4px rgba(0, 0, 0, 0.3)",
	boxSizing: "border-box",
	color: theme.project.colors.primaryColors.main,
	display: "flex",
	flexDirection: "column",
	fontFamily: "inherit",
	height: 250,
	justifyContent: "flex-start",
	padding: "32px 20px 20px",
	width: 250,

	"&:focus-visible": {
		outline: `2px solid ${theme.project.colors.primaryColors.main}`,
		outlineOffset: 3
	}
});

export const OptionButton = styled.button(({ theme }) => optionStyles(theme));

export const OptionLink = styled.a(({ theme }) => ({
	...optionStyles(theme),
	textDecoration: "none"
}));

export const OptionImage = styled.img<{ imageWidth?: number }>(({ imageWidth }) => ({
	height: 100,
	objectFit: "contain",
	width: imageWidth ?? "auto"
}));

export const OptionLabel = styled.span(({ theme }) => ({
	...theme.project.typography.body.body1,
	color: theme.project.colors.primaryColors.main,
	fontSize: 24,
	fontWeight: 500,
	lineHeight: "124%",
	letterSpacing: "0.15px",
	marginTop: 8,
	textAlign: "center"
}));

export const OptionSkeleton = styled(Skeleton)({
	height: 250,
	transform: "none",
	width: 250
});
